import { data } from '../../svg/Mail/data';
import { makeIcon } from '../makeIcon';

export const Mail = makeIcon(data, 'mail', 'Mail');

export default Mail;
